import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["group", "scoped"]

  connect() {
    this.update()
  }

  update() {
    const groupId = this.hasGroupTarget ? this.groupTarget.value : ""

    this.scopedTargets.forEach((element) => {
      const groupIds = (element.dataset.groupIds || "").split(",").filter(Boolean)
      const groupMatches = groupIds.length === 0 || groupIds.includes(groupId)
      const parentScope = element.parentElement && element.parentElement.closest('[data-target~="event-registration-public.scoped"]')
      const visible = (!parentScope || !parentScope.hidden) && groupMatches && this.conditionMatches(element)

      element.hidden = !visible
      element.querySelectorAll("input, select, textarea").forEach((input) => {
        input.disabled = !visible || input.dataset.permanentlyDisabled === "true"
      })
    })
  }

  conditionMatches(element) {
    const questionId = element.dataset.conditionQuestionId
    if (!questionId) return true

    const expected = element.dataset.conditionValue
    const prefix = `event_registration_submission[answers][${questionId}]`
    const inputs = Array.from(this.element.querySelectorAll("input, select, textarea"))
      .filter((input) => input.name === prefix || input.name === `${prefix}[]`)

    return inputs.some((input) => {
      if (input.type === "radio" || input.type === "checkbox") return input.checked && input.value === expected
      return input.value === expected
    })
  }
}
